import React, { Component } from 'react';
import './Loading.css';
import Utils from '../../../base/Utils';

class Loading extends Component {
    availableSizes = ['Small', 'Medium', 'Big'];
    availableTypes = ['Normal', 'Fill'];
    
    render() {
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        var type = Utils.checkAvailability(this.availableTypes, this.props.type, true);
        
        var classValue = "Loading " + size + " " + type;
        
        return <div className={classValue}>
        <div className="LoadingWrap">
        <div className="LoadingAnimation"></div>
        </div>
        </div>;
    }
}

export default Loading;
